/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-27 19:30:38
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-23 11:11:06
 * @Description: file content
 * 
 */
// const Mock = require('mockjs');
export default {
    protocol: "",
    domain: "",
    action: {
        this: null,
        saveUserInfo: {
            api: "/yq-api/activity/logic/saveUserInfo",
            mock: function() {
                return {
                    msg: "success",
                    code: 0,
                    data: {
                        value: "这里是假数据"
                    }
                }
            }
        },
        actInfo: "/yq-api/activity/logic/actInfo",
        addBrowseCount: "/yq-api/activity/logic/addBrowseCount",
        userJoinfo: "/yq-api/activity/logic/userJoinfo",
        checkValidIp: "/yq-api/activity/logic/checkValidIp",
        takeMobileVerifyCode: "/yq-api/activity/logic/takeMobileVerifyCode",
        takeTelFareAndCheckVCode: "/yq-api/activity/logic/takeTelFareAndCheckVCode",
        userPrize: {
            api: "/yq-api/activity/logic/userPrize",
            mode: "get"
        },
        share: "/yq-api/activity/logic/share",
        awardPrize: "/yq-api/activity/logic/awardPrize",
        assistanceOnece: "/yq-api/activity/logic/assistanceOnece",
        getAssistancecount: "/yq-api/api/national/getAssistancecount",
        userAssistancePage: "/yq-api/activity/logic/userAssistancePage",
        selectpx: "/yq-api/api/national/selectpx",
        // 通用获取奖品编号，一般用于大转盘
        getPrizeCode: "/yq-api/api/national/getPrizeCode",
        getOfflinePrizepx: "/yq-api/api/national/getOfflinePrizepx",
        getOfflinePrize: "/yq-api/api/national/getOfflinePrize",
        joinAct: "/yq-api/activity/logic/joinAct",
        // 获取排行榜
        joinUserList: {
            api: "/yq-api/activity/logic/joinUserList",
            mode: "get"
        },
        rankMock: {
            api: "/yq-api/activity/rankMock",
            mode: "post",
            mock: function() {
                let arr = [{ "rank": 1, "openId": "oCfek1ENGkk6ODgtV8SAUTRC9OtE", "nickName": "张翔", "headImg": "http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83erzB9UclmfbmDRyO1OBiaJqDDF4bGjM2YOSMBNGxia8XZBibZutnfQIH5bV7hfRibZPOMRK3GRm80H5Dg/132", "rankCount": 4, "url": "https://assets.media.rurushishi.com/wx1b2b96ed40674488p1/1832508972.mp3" },
                    { "rank": 2, "openId": "oCfek1Eh1yhHYj8llHgSKThnWHTk", "nickName": "砥砺", "headImg": "http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKWEhIJLCiaIyQUDqsaQpuJAlWpGDaSSEmn3Gtg00nwksYJaZUfCrmjw75aVh9NDpk7jE1g238icIKA/132", "rankCount": 1, "url": "https://assets.media.rurushishi.com/wx1b2b96ed40674488p1/472748376.mp3" },
                    { "rank": 3, "openId": "oCfek1ChGQWEB_d8-S1_RmqoboDk", "nickName": "Aragorn", "headImg": "http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eqTYPU2fGOyibqIDZgxjjzNsibljWWRxibq5oiaJTVDbIRicF9PELr4kIQfZdvqoCKJPsKt9hVWx5a3gHg/132", "rankCount": 1, "url": "https://assets.media.rurushishi.com/wx1b2b96ed40674488p1/960357223.mp3" }
                ];
                arr = arr.concat(arr); //6
                arr = arr.concat(arr); //12
                arr = arr.concat(arr); //24
                arr = arr.slice(0, 20); //返回20条
                return {
                    "msg": "success",
                    "code": 0,
                    "data": arr
                }
            }
        },
        logic: {
            // 获取奖品编号
            getPrizeCode: {
                api: "/yq-api/activity/logic/getPrizeCode",
                mode: "get"
            },
            // 获取用户的奖品列表
            userPrizename: {
                api: "/yq-api/activity/logic/userPrizename",
                mode: "get"
            },
            // 获取奖品配置
            getPrizeModels: {
                api: "/yq-api/activity/logic/getPrizeModels",
                mode: "get"
            },
        },
        "jsby-jwf": {
            // 查询用户当日的游戏次数 和是否领过大转盘奖品
            getPerson: {
                api: "/yq-api/api/fivefu/getPerson",
                mode: "get"
            },
            // 保存第一次福卡
            savefirst: {
                api: "/yq-api/api/fivefu/savefirst",
                mode: "get"
            },
            // 给好友助力或者投票，只能给好友助力一次
            assistanceOnecejn: {
                api: "/yq-api/api/fivefu/assistanceOnecejn",
                mode: "get"
            },
            // 大转盘领取线下奖品
            getOfflinePrize: {
                api: "/yq-api/api/fivefu/getOfflinePrize",
                mode: "post"
            }
        },
        // 用济水别苑集五福活动做demo jsby-jwf
        "demo": {
            // 查询用户当日的游戏次数 和是否领过大转盘奖品
            getPerson: {
                api: "/yq-api/api/fivefu/getPerson",
                mode: "get"
            },
            // 保存第一次福卡
            savefirst: {
                api: "/yq-api/api/fivefu/savefirst",
                mode: "get"
            },
            // 给好友助力或者投票，只能给好友助力一次
            assistanceOnecejn: {
                api: "/yq-api/api/fivefu/assistanceOnecejn",
                mode: "get"
            },
            // 大转盘领取线下奖品
            getOfflinePrize: {
                api: "/yq-api/api/fivefu/getOfflinePrize",
                mode: "post"
            }
        },
        "jbzytj-2020": {
            // 保存用户信息
            saveUserInfo: {
                api: "/yq-api/activity/keppel/saveUserInfo",
                mode: "post"
            },
            // 获取用户中的签
            getUserLotRecord: {
                api: "/yq-api/activity/keppel/getUserLotRecord",
                mode: "get"
            },
            // 中了几种签
            getUserLots: {
                api: "/yq-api/activity/keppel/getUserLots",
                mode: "get"
            },
            // 保存用户抽取的签
            saveUserLuckLot: {
                api: "/yq-api/activity/keppel/saveUserLuckLot",
                mode: "post"
            },
            // 分享活动
            share: {
                api: "/yq-api/activity/keppel/share",
                mode: "post"
            },
            // 抽取最后一个签
            drawLuckLot: {
                api: "/yq-api/activity/keppel/drawLuckLot",
                mode: "get"
            },
            // 打开福袋
            openLuckPackage: {
                api: "/yq-api/activity/keppel/openLuckPackage",
                mode: "get"
            },
            // 获取锦鲤签的打开状态
            checkOpen: {
                api: "/yq-api/activity/keppel/checkOpen",
                mode: "get"
            }

        },
        foshan: {
            joinAct: "/yq-api/api/foshan/joinAct",
            getGameCount: "/yq-api/api/foshan/getGameCount",
            reduceGameCount: "/yq-api/api/foshan/reduceGameCount",
            gethf: "/yq-api/api/foshan/gethf",
            saveScore: "/yq-api/api/foshan/saveScore",
            save: "/yq-api/api/foshan/save",
            getCircleCount: "/yq-api/api/foshan/getCircleCount",
            getPrizeCode: "/yq-api/api/foshan/getPrizeCode",
            assistanceOnceWithPrizeCode: "/yq-api/api/foshan/assistanceOnceWithPrizeCode",
            getNowTime: "/yq-api/api/foshan/getNowTime",
        },
        hf20: {
            // 给好友助力或者投票，只能给好友助力一次
            assistanceOnece: "/yq-api/api/christmas/assistanceOnece",
            // 验证核销码
            checkcode: "/yq-api/api/christmas/checkcode",
            // 查询是否核销过code和许过愿望
            get: {
                api: "/yq-api/api/christmas/get",
                mode: "get",
                mock: function() {
                    return {
                        msg: "success",
                        code: 0,
                        data: {
                            wish: 1,
                            offcode: 0,
                            assistance: 128
                        }
                    }
                }
            },
            // 获取分享人的头像昵称和愿望
            getfPerson: "/yq-api/api/christmas/getfPerson",
            // 获取奖品编号
            getPrizeCode: {
                api: "/yq-api/api/christmas/getPrizeCode",
                mock: function() {
                    return {
                        msg: "success",
                        code: 0,
                        data: "prize_5"
                    }
                }
            },
            // 我的奖品页面查询奖品是否充足和是否需要验证码
            getPrizeEnough: "/yq-api/api/christmas/getPrizeEnough",
            // 领取我的奖品
            receivePrize: "/yq-api/api/christmas/receivePrize",
            // 保存用户许愿信息
            save: {
                api: "/yq-api/api/christmas/save",
                mode: "get"
            },
            getOfflinePrize: "/yq-api/api/christmas/getOfflinePrize",
        },
    }
}